import UserError from './UserError.js'

export class GetConversationUserError extends UserError {}
